import { RootState } from "@/redux/store";

export const fleetOptionsSelector = (state: RootState) => state.driver.fleet.options;
export const offloadDriversSelector = (state: RootState) => state.driver.offload.drivers;
export const offloadDriversPageSelector = (state: RootState) => state.driver.offload.page;
export const offloadOptionsSelector = (state: RootState) => state.driver.offload.options;
export const payoutsSelector = (state: RootState) => state.driver.payout.payouts;
export const payoutsPageSelector = (state: RootState) => state.driver.payout.page;
